import React, { useRef } from "react";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import VenueSection from "../../components/VenueSection/VenueSection";
import InviteeSection from "../../components/InviteeSection/InviteeSection";
import EventSection4 from "../../components/EventSection4/EventSection4";
import QuoteSection from "../../components/QuoteSection/QuoteSection";
import Hero from "../../components/hero/Hero";
import CoupleSection3 from "../../components/CoupleSection3/CoupleSection3";
import BottomSection from "../../components/BottomContainer/BottomContainer";
import RsvpSectionS2 from "../../components/RsvpSectionS2/RsvpSectionS2";
import LetterEnvelope from "../../components/LetterEnvelope/LetterEnvelope";

const EternalGrace = () => {
  const containerRef = useRef(null);
  return (
    <div ref={containerRef} className={`fadeInSlow scroll-container`}>
      <Hero />
      <CoupleSection3 />
      <LetterEnvelope />
      <QuoteSection />
      <EventSection4 haveBackground={true} />
      <VenueSection />
      <RsvpSectionS2 />
      <InviteeSection haveBackground={true} />
      <BottomSection />
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </div>
  );
};

export default EternalGrace;
